import * as yup from "yup";

const message = yup.string().when("reason.tag", {
  is: (val: string) => val === "OTH300",
  then: (schema) => schema.required(),
  otherwise: (schema) => schema.optional(),
});

const reason = yup.object({
  name: yup.string().required(),
  tag: yup.string().required(),
});

export const validationSchema = yup.object({
  reason,
  message,
});
